export const SIE_ID_HEIGHT = 35;
export const ADDITIONAL_ELEMENTS_STATIC_HEIGHT = 210;
export const CLOSE_CHART_HEIGHT = 135;
export const CHART_HEIGHT_ON_DASHBOARD = 500;
export const PADDING_FILTER = 40;
export const CHART_HEIGHT_ON_MAP = 300;
export const ONE_COLUMN = 1;
export const TWO_COLUMN = 2;
